<template>
  <div class="container">
    <div class="title">欢迎来到网上照明展</div>
    <div class="inpuBox">
      <div class="itemBox">
        <span>账号</span>
        <input 
          v-model="account" 
          type="text" 
          placeholder="请输入账号"
        />
      </div>
      <div class="itemBox">
        <span>密码</span>
        <input
          v-model="pwd"
          :type="show?'password':'text'"
          placeholder="请输入密码"
          style="width: 110px"
        />
        <img src="../../../static/images/icon/visible.png" @click.stop="clickSee" v-if="show" />
        <img src="../../../static/images/icon/browes.png" @click.stop="clickSee" v-else />
        <button @click.stop="showDialogBtn">忘记密码</button>
      </div>
      <div class="loginBtn" @click.stop="formSubmit">登录</div>
      <div class="other">其他登录方式</div>
      <div class="bigBox">
        <router-link class="imgBox" to="/codeLogin">
          <div class="img">
            <img
              src="../../../static/images/icon/phone.png"
              style="width: 15px; height: 23px"
            />
          </div>
          <div class="desc">手机号快速登录</div>
        </router-link>
      </div>
    </div>
    <van-overlay :show="showModal" @click="showModal = false">
      <div class="modal-dialog" v-if="showModal">
        <img src="../../../static/images/icon/prompt.png" />
        <div class="modal-content">
          如果您忘记了账号密码，请选择手机号快速登录。
        </div>
        <div class="modal-footer" @click="showModal = false">我知道了</div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { Overlay } from "vant";
import { accountLogin } from "@/api/login";
export default {
  name: "phoneLogin",
  components: {
    "van-overlay": Overlay,
  },
  data() {
    return {
      account: "",
      pwd: "",
      show: true, //是否开启密码
      showModal: false, //弹窗
    };
  },
  methods: {
    //点击忘记密码
    showDialogBtn() {
      this.showModal = true;
    },

    //密码弹窗判断
    clickSee: function () {
      this.show = !this.show;
    },

    //登录
    formSubmit() {
      var that = this;
      if (that.account == "") {
        that.Common.showMsg("请输入用户名");
        return false;
      }
      if (that.pwd == "") {
        that.Common.showMsg("请输入密码");
        return false;
      }
      accountLogin({ Account: that.account, PWD: that.pwd }).then((res) => {
        // that.tim.logout();
        localStorage.token = res.Msg;
        localStorage.setItem("mid", res.Data.MemberID);
        // getImUserSig().then((sig) => {
        //   that.tim
        //     .login({
        //       userID: res.Data.MemberID.toString(),
        //       userSig: sig.Data,
        //     })
        //     .then(() => {
        //       that.loading = false;
        //       console.log("timlogin");
        //       that.$store.commit("toggleIsLogin", true);
        //       that.$store.commit("startComputeCurrent");
        //       that.$store.commit({
        //         type: "GET_USER_INFO",
        //         userID: res.Data.MemberID.toString(),
        //         userSig: sig.Data,
        //         sdkAppID: 1400356039,
        //       });
              var beforeLoginUrl = localStorage.beforeLoginUrl;
              if (beforeLoginUrl) {
                location.href = beforeLoginUrl;
                localStorage.removeItem("beforeLoginUrl");
              } else {
                that.$router.push({ path: "/" });
              }
        //       console.log("timloginend");
        //     });
        // });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  .title {
    text-align: center;
    font-size: 26px;
    color: #333;
    margin: 60px;
  }
  .inpuBox {
    .itemBox {
      height: 56px;
      line-height: 56px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #999;
      margin: 0px 37px;
      font-size: 14px;
      span{
        width: 60px;
      }
      input {
        width: calc(100% - 60px);
        border: none;
      }
      img {
        margin-right: 13px;
        width: 18px;
        height: 15px;
      }
      button {
        border: none;
        background-color: transparent;
        color: #666;
        border-left: 1px solid #ddd;
        width: 100px;
        height: 14px;
        line-height: 14px;
      }
    }
    .loginBtn {
      width: 300px;
      height: 40px;
      line-height: 40px;
      background: rgba(235, 78, 78, 1);
      border-radius: 20px;
      color: #fff;
      font-size: 16px;
      text-align: center;
      margin: 34px 37px 90px 37px;
      -webkit-border-radius: 20px;
      -moz-border-radius: 20px;
      -ms-border-radius: 20px;
      -o-border-radius: 20px;
    }
    .other {
      font-size: 11px;
      color: #999;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      &::after {
        content: "";
        display: block;
        width: 117px;
        background-color: #ddd;
        height: 1px;
        position: absolute;
        left: 27px;
      }
      &::before {
        content: "";
        display: block;
        width: 117px;
        background-color: #ddd;
        height: 1px;
        position: absolute;
        right: 27px;
      }
    }
    .bigBox {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-top: 32px;
      .imgBox {
        display: flex;
        align-items: center;
        flex-direction: column;
        .img {
          width: 40px;
          height: 40px;
          line-height: 40px;
          border: 1px solid rgba(207, 207, 207, 1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .desc {
          font-size: 12px;
          color: #999;
          margin-top: 7px;
        }
      }
    }
  }
  .modal-dialog {
    width: 325px;
    background: rgba(255, 255, 255, 1);
    border-radius: 3px;
    text-align: center;
    font-size: 13px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 32px;
      height: 32px;
      padding: 27px 0px;
    }
    .modal-content {
      padding-bottom: 25px;
    }
    .modal-footer {
      height: 48px;
      line-height: 48px;
      color: #666;
      border-top: 1px solid #dedede;
    }
  }
}
</style>
